import { FC } from 'react';

import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next/pages';

import cn from 'classnames';

import { MAKE_MAIN_URL, SPBEX_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import { Footer } from '../Footer/Footer';

import styles from './Digest.module.scss';

export const Digest: FC = () => {
	const { t } = useTranslation(TranslationNamespace.PressRelease);

	return (
		<>
			<div className={styles.topContainer}>
				<div className={styles.header}>
					<h1 className={cn(styles.container, styles.title, styles.headerText)}>{t('title')}</h1>
				</div>
				<div className={styles.container}>
					<div className={styles.content}>
						<div className={styles.description}>
							{t('intro-p1-prefix')}{' '}
							<Link href={MAKE_MAIN_URL()} className={styles.link} target="_blank">
								{t('intro-p1-link')}
							</Link>{' '}
							{t('intro-p1-suffix')}
							<br />
							<br />
							<Trans
								ns={TranslationNamespace.PressRelease}
								i18nKey="intro-p2"
								components={{ b: <b /> }}
							/>
							<br />
							<br />
							<Trans
								ns={TranslationNamespace.PressRelease}
								i18nKey="intro-p3"
								components={{ b: <b /> }}
							/>
						</div>

						<div className={styles.section}>
							<h2 className={styles.subTitle}>{t('section1-title')}</h2>
							<div className={styles.description}>
								{t('section1-p1')}
								<br />
								<br />
								{t('section1-p2')}
								<br />
								<br />
								<Trans
									ns={TranslationNamespace.PressRelease}
									i18nKey="section1-quote-intro"
									components={{ b: <b /> }}
								/>
								<br />
								<br />
								<Trans
									ns={TranslationNamespace.PressRelease}
									i18nKey="section1-quote"
									components={{ b: <b /> }}
								/>
							</div>
						</div>

						<div className={styles.section}>
							<h2 className={styles.subTitle}>{t('section2-title')}</h2>
							<div className={styles.description}>
								{t('section2-p1')}
								<br />
								<br />
								<Trans
									ns={TranslationNamespace.PressRelease}
									i18nKey="section2-quote-intro"
									components={{ b: <b /> }}
								/>
								<br />
								<br />
								<Trans
									ns={TranslationNamespace.PressRelease}
									i18nKey="section2-quote"
									components={{ b: <b /> }}
								/>
							</div>
						</div>

						<div className={styles.section}>
							<h2 className={styles.subTitle}>{t('section3-title')}</h2>
							<div className={styles.description}>
								{t('section3-intro')}
								<br />
								<ul>
									<li>{t('section3-li1')}</li>
									<li>{t('section3-li2')}</li>
									<li>{t('section3-li3')}</li>
									<li>{t('section3-li4')}</li>
								</ul>
								{t('section3-outro')}
							</div>
						</div>

						<div className={styles.section}>
							<h2 className={styles.subTitle}>{t('section4-title')}</h2>
							<div className={styles.description}>
								<Trans
									ns={TranslationNamespace.PressRelease}
									i18nKey="section4-fishplace"
									components={{ b: <b /> }}
								/>
								<br />
								<br />
								<Trans
									ns={TranslationNamespace.PressRelease}
									i18nKey="section4-exchange-intro"
									components={{ b: <b /> }}
								/>{' '}
								<a className={styles.link} href={SPBEX_URL} target="_blank" rel="noreferrer">
									{t('section4-exchange-link')}
								</a>{' '}
								{t('section4-exchange-suffix')}
							</div>
						</div>
					</div>

					<div className={styles.secondaryContent}>{t('location')}</div>
				</div>
			</div>
			<Footer />
		</>
	);
};
